/**
 * analytics.ts
 *
 * Thin wrapper around the Google tag (gtag.js), loaded via the inline <script> blocks in
 * index.html's <head> (not an npm package), used to report conversion events for a Google Ads
 * campaign. gtag() is a global defined by that inline script -- declared here as an ambient
 * global so TypeScript recognizes it, and guarded with a typeof check so this stays harmless if
 * gtag.js failed to load (e.g. blocked by an ad blocker/privacy extension) or during local dev.
 */

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * Reports the "Purchase" Google Ads conversion. Fired when a user clicks the Donate link --
 * the closest equivalent this donation-based site has to a purchase/checkout event. No
 * transaction_id is sent: the actual payment happens off-site on PayPal, which this app has no
 * way to observe or confirm, so this only measures click-throughs to the donate flow, not
 * completed donations.
 */
export function reportDonateClickConversion(): void {
  if (typeof window.gtag === "function") {
    window.gtag("event", "conversion", {
      send_to: "AW-18163894416/SHS3CM_c05odEJCRnNVD"
    });
  }
}
